export const EMAIL_BUILDER_CANVAS_VERTICAL_RAIL_GAP_PX = 8;
export const EMAIL_BUILDER_CANVAS_LEFT_RAIL_GUTTER_PX = 44;

export function emailBuilderUsesVerticalLeftCanvasRail(
  usesDesktopRightSettingsPanel: boolean,
  usesCompactSettingsChrome: boolean,
): boolean {
  return usesDesktopRightSettingsPanel || usesCompactSettingsChrome;
}
